// @flow
export const convertCurrencyValue = (
    conversions: any[],
    sourceCurrency: string,
    targetCurrency: string,
    value: number
) => {
    // conversions.currencyCode lookup is stored in UPPERCASE
    const targetCurrencyCode = targetCurrency.toUpperCase();
    const sourceCurrencyCode = sourceCurrency.toUpperCase();
    if (targetCurrencyCode === sourceCurrencyCode) {
        return value;
    }
    const targetConversion = conversions.find(c => c.currencyCode.toUpperCase() === targetCurrencyCode) || {
        conversionToUsd: 1,
    };

    let convertedValue;
    if (targetCurrencyCode === 'USD') {
        convertedValue = value * targetConversion.conversionToUsd;
    } else {
        const sourceConversion = conversions.find(c => c.currencyCode.toUpperCase() === sourceCurrencyCode) || {
            conversionToUsd: 1,
        };
        convertedValue = value * (1 / sourceConversion.conversionToUsd) * targetConversion.conversionToUsd;
    }
    return convertedValue;
};
